import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await axios.post(`${API}/admin/login`, { username, password });
      localStorage.setItem("admin_token", res.data.token);
      localStorage.setItem("admin_username", res.data.username);
      navigate("/admin/dashboard");
    } catch (e) {
      setError("Invalid credentials. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-champagne flex items-center justify-center px-6" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <div className="text-center mb-8">
          <h1 className="font-heading text-3xl font-semibold text-charcoal">Admin Panel</h1>
          <p className="font-body text-sm text-charcoal-light mt-1">Journey With Joyce Lim</p>
        </div>

        <form
          onSubmit={handleLogin}
          className="bg-white border border-border rounded-2xl p-8 space-y-5"
          data-testid="admin-login-form"
        >
          {error && (
            <div className="bg-destructive/10 text-destructive px-4 py-3 rounded-xl font-body text-sm" data-testid="admin-login-error">
              {error}
            </div>
          )}
          <div>
            <label className="block font-body text-sm font-medium text-charcoal mb-1.5">Username</label>
            <input
              type="text" required value={username}
              onChange={(e) => setUsername(e.target.value)}
              data-testid="admin-username-input"
              className="w-full px-4 py-3 rounded-xl border border-border bg-champagne font-body text-sm text-charcoal focus:outline-none focus:ring-2 focus:ring-navy/30 focus:border-navy transition-all"
              placeholder="Enter username"
            />
          </div>
          <div>
            <label className="block font-body text-sm font-medium text-charcoal mb-1.5">Password</label>
            <input
              type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="w-full px-4 py-3 rounded-xl border border-border bg-champagne font-body text-sm text-charcoal focus:outline-none focus:ring-2 focus:ring-navy/30 focus:border-navy transition-all"
              placeholder="Enter password"
            />
          </div>
          <button
            type="submit" disabled={loading}
            data-testid="admin-login-btn"
            className="w-full bg-navy text-white py-3.5 rounded-full font-body font-semibold hover:bg-navy-light transition-all hover:scale-[1.02] shadow-soft disabled:opacity-50 flex items-center justify-center gap-2"
          >
            <Lock className="w-4 h-4" /> {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
